<template>
    <div class="max-w-7xl mx-auto px-6 lg:px-8">
        <PageTitle v-bind:title="title" v-bind:admin="false" />
    </div>
</template>
<script>
import PageTitle from "@/components/PageTitle";
export default {
    data() {
        return {
            title: 'Руководство'
        }
    },
    components: {
        PageTitle,
    }
}
</script>